var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-8',{attrs:{"dur":0,"color":['#83bff6', '#00CED1'],"background-color":"transparent"}})
}
var staticRenderFns = []

export { render, staticRenderFns }